module.exports = __webpack_public_path__ + "img/produits.c28f83a2.webp";